"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

import { useSchedulingRole } from "@calcom/web/lib/scheduling/useSchedulingRole";

const SCHEDULING_MANAGER_ALLOWED_MAIN_NAV_PREFIXES = [
  "/bookings",
  "/insights",
  "/scheduling-access",
  "/settings",
];

export function SchedulingManagerPageGuard() {
  const { isSchedulingManager, isLoading } = useSchedulingRole();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (isLoading || !isSchedulingManager) return;
    const isAllowed = SCHEDULING_MANAGER_ALLOWED_MAIN_NAV_PREFIXES.some((prefix) =>
      pathname?.startsWith(prefix)
    );
    if (!isAllowed) {
      router.replace("/bookings");
    }
  }, [isSchedulingManager, isLoading, pathname, router]);

  return null;
}
